(function() {
    angular.module('tmx-app').controller('tatSummaryReportCtrl', [
        '$mdSidenav',
        'tmxUtility',
        'menu',
        '$mdMedia',
        'BranchService',
        'LoanProductService',
        'LoanApplicationService',
        'ReportService',

        function TatSummaryReportCtrl(
            $mdSidenav,
            tmxUtility,
            menu,
            $mdMedia,
            BranchService,
            LoanProductService,
            LoanApplicationService,
            ReportService
        ) {
            var vm = this;
            vm.menu = menu;
            vm.gridData = new kendo.data.ObservableArray([]);
            vm.search = search;
            vm.filterEnabled = false;
            vm.disableStates = true;
            vm.toggle = toggle;
            vm.isOpen = isOpen;
    
            vm.clear = clear;
            vm.formatColumnName = tmxUtility.formatColumnName;
            vm.formatDateTime=tmxUtility.formatDateTimeForCompany;
            var GridColumns = [
                {
                    field: tmxUtility.formatColumnName('LoanApplicationNumber'),
                    title: "LoanApplicationNumber",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[TatSummaryReportCtrl.formatColumnName('LoanApplicationNumber')]}}</span>",
                    headerTemplate: "<span>Loan Application #</span>"                        
                },
                {
                    field: tmxUtility.formatColumnName('LoanApplicationDate'),
                    title: "LoanApplicationDate",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{TatSummaryReportCtrl.formatDateTime(dataItem[TatSummaryReportCtrl.formatColumnName('LoanApplicationDate')])}}</span>",
                    headerTemplate: "<span>Application Date</span>"                        
                },
                {
                    field: tmxUtility.formatColumnName('ApprovedLoanAmount'),
                    title: "ApprovedLoanAmount",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span>{{dataItem[TatSummaryReportCtrl.formatColumnName('ApprovedLoanAmount')]}}</span>",
                    headerTemplate: "<span>Approved Loan Amount</span>"                        
                },
                {
                    field: tmxUtility.formatColumnName('FromState'),
                    title: "FromState",
                    type: "text",
                    template: "<span >{{dataItem[TatSummaryReportCtrl.formatColumnName('FromState')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>From State</span>"
                },                
                {
                    field: tmxUtility.formatColumnName('ToState'),
                    title: "ToState",
                    type: "text",
                    template: "<span >{{dataItem[TatSummaryReportCtrl.formatColumnName('ToState')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>To State</span>"
                },              
                {
                    field: tmxUtility.formatColumnName('statestartdate'),
                    title: "State Start Date",
                    type: "text",                    
                    template: "<span >{{TatSummaryReportCtrl.formatDateTime(dataItem[TatSummaryReportCtrl.formatColumnName('statestartdate')])}}</span>",
                    headerTemplate: "<span>State Start Date</span>"
                },
                {
                    field: tmxUtility.formatColumnName('transitiontime'),
                    title: "State End Date",
                    type: "text",                    
                    template: "{{TatSummaryReportCtrl.formatDateTime(dataItem[TatSummaryReportCtrl.formatColumnName('transitiontime')])}}",
                    headerTemplate: "<span>State End Date</span>"
                },
                {
                    field: tmxUtility.formatColumnName('TurnAroundTime'),
                    title: "TurnAroundTime",
                    type: "text",
                    template: "<span >{{dataItem[TatSummaryReportCtrl.formatColumnName('TurnAroundTime')]}}</span>",
                    headerTemplate: "<span>Turn Around Time</span>"
                },
            ];

            function isOpen(navID) {
                return $mdSidenav(navID).isOpen();
            }
            function clear() {
                vm.LoanApplicationNumber = null;
                vm.BranchId=null;
                vm.ApplicationDate=null;
                vm.StartState=null;
                vm.EndState=null;
                vm.ProductId=null;
                vm.container.reportGrid.dataSource.read();
            }

            (function PopulateLovs(){
                BranchService.getByAction('GetBranchesByUserCompany',true).then(function(response){
                    vm.Branches=response.data.map(x=> { return {LookupId:x.CompanyBranchId, HiddenValue : x.BranchCode, VisibleValue : x.BranchName}});
                });

                var productRes = LoanProductService.getAllLoanProducts();
                if(productRes.$$state.value && productRes.$$state.value.data && productRes.$$state.value.data.length > 0) {
                    vm.Products = productRes.$$state.value.data.map(x=> { return {LookupId:x.ProductId, HiddenValue : x.ProductId, VisibleValue : x.ProductName}});
                }
            })();

            vm.OnProductSelected = function (productId) {
                vm.StartState=null;
                vm.EndState=null;
                if (tmxUtility.exists(productId)) {
                    vm.disableStates = false;
                    LoanApplicationService.getWorkflowStatesByProductId(productId).then(function (response) {
                        if (tmxUtility.exists(response, 'data')) {
                            vm.States = response.data.map(x=>{
                                if(x.Name !="")
                                    return {
                                        VisibleValue: x.VisibleName,
                                        HiddenValue: x.Name
                                    }
                            });
                        }
                        else {
                            vm.States = [];
                        }
                    });
                }
                else {
                    vm.disableStates = true;
                }
            }

            function toggle() {
                $mdSidenav("ExportSideNav")
                    .toggle()
                    .then(function() {});
            }

            vm.exportToPdf = exportToPdf;

            function search() {
                vm.container.reportGrid.dataSource.read();
                vm.filterEnabled = true;
            }

            function exportToPdf() {
                var applicationdate='';
                var offset=null;
                offset= -1 * (new Date().getTimezoneOffset());
                if (vm.ApplicationDate) {
                    applicationdate = moment(new Date(vm.ApplicationDate)).endOf('day').toISOString().replace("Z", "");                            
                }
                
                var args = {
                    ApplicationDate: applicationdate || null,
                    BranchId:vm.BranchId || 0,
                    LoanApplicationNumber:vm.LoanApplicationNumber || null,
                    offset:offset || 0,
                    StartState:vm.StartState || null,
                    EndState:vm.EndState || null
                }
                ReportService.ReportPDF({ StoredProcedure: 'sp_tat_summary_report', ReportName: 'TAT_Summary_Report', Orientation: 'Portrait', Arguments: args});

            }

            vm.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function(o) {
                            var applicationdate='';
                            var offset=null;

                            offset= -1 * (new Date().getTimezoneOffset());

                            if (vm.ApplicationDate) {
                                applicationdate = moment(new Date(vm.ApplicationDate)).endOf('day').toISOString().replace("Z", "");                            
                            }

                            var objArgs = {
                                "ApplicationDate": applicationdate || null,
                                "BranchId":vm.BranchId || null,
                                "LoanApplicationNumber":vm.LoanApplicationNumber || null,
                                "offset":offset || 0,
                                "StartState":vm.StartState || null,
                                "EndState":vm.EndState || null
                            };
              
                            var filters = {
                                "StoredProcedure": "sp_tat_summary_report",
                                "Arguments": objArgs,
                                "ReportName": "TAT_Summary_Report"
                            };

                            vm.o = angular.copy(o);
                            vm.filters = vm.o.data.filter;
                            firebase.logTmxEvent('report',{name:'TAT Summary Report'});
                            ReportService.putByParams(o, true, "ReportDataSourceResultPost", filters).then(function (response) {
              
                                if (response) {
                                    vm.GridResponseData = response.Data;
                                    o.success(response);
                                }
                            });
  
                            vm.filterEnabled = true;
            
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "data.length"
                        
                    },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false,
                },
                pageable: {
                    refresh: true,
                    pageSizes: [5, 10, 15, 20, 100, "All"],
                    pageSize: 15,
                    buttonCount: 4
                },
                excel: {
                    allPages: true,
                    fileName: "TATSummaryReport.xlsx"
                },
                excelExport: function(e) {
                    var sheet = e.workbook.sheets[0];
                    var columns = e.workbook.sheets[0].columns;
                    for (var rowIndex = 1; rowIndex < sheet.rows.length; rowIndex++) {


                        var row = sheet.rows[rowIndex];
                        row.cells[1].value = vm.formatDateTime(row.cells[1].value);
                        row.cells[4].value = vm.formatDateTime(row.cells[4].value);
                        row.cells[5].value = vm.formatDateTime(row.cells[5].value);
                    }
                    columns.forEach(function(column) {
                        delete column.width;
                        column.autoWidth = true;
                    });
                },
                sortable: true,
                scrollable: !$mdMedia("gt-sm"),

                    
                columns: GridColumns
            };
        }
    ]);
})();
